<template>
  <div class="wrap">
    <v-data-table class="app-table" v-model="selected" :headers="headers" :items="data" :single-select="singleSelect" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer="hide-default-footer" item-key="name" @page-count="pageCount = $event" :no-data-text="$t('common.nodata')"></v-data-table>
    <div class="text-center mt-10">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: this.$t('tableUserRentalRecord.headers.startAt'), value: 'startAt' },
        { text: this.$t('tableUserRentalRecord.headers.endAt'), value: 'endAt' },
        { text: this.$t('tableUserRentalRecord.headers.totalPeriod'), value: 'totalPeriod' }
      ]
    }
  }
}
</script>
